import ViewLibraryBook from '~/components/library/view/ViewLibraryBook.vue';
import ViewLibraryDefaultShelf from '~/components/library/view/ViewLibraryDefaultShelf.vue';
import ViewLibraryDefaultLb from '~/components/library/view/ViewLibraryDefaultLb.vue';
import ViewLibraryShelf from '~/components/library/view/ViewLibraryShelf.vue';
import ViewLibraryShelfSingle from '~/components/library/view/ViewLibraryShelfSingle.vue';
import ViewLibraryRoot from '~/components/library/view/ViewLibraryRoot.vue';

import type { LibrarySchema, LibraryBookSchema } from '~/types/schema';
import { LibraryTypes } from '~/types/adamTypes';

export type UseLibraryViewRouter = {
  view: any;
};

export const INJECT_LIBRARY_VIEW_ROUTER = Symbol(
  'useLibraryViewRouter composable'
) as InjectionKey<UseLibraryViewRouter>;

export const useLibraryViewRouter = (
  library: Ref<LibrarySchema> | LibrarySchema,
  libraryBook: Ref<LibraryBookSchema> | LibraryBookSchema
) => {
  const hasParentShelf = (parents) => {
    const index = parents.findIndex(
      (parent) => parent.type === LibraryTypes.Shelf
    );
    return index !== -1;
  };
  const view = shallowRef<Component>();

  const getView = () => {
    if (!toValue(libraryBook) && !toValue(library)) return;
    if (toValue(libraryBook)) return ViewLibraryBook;
    switch (toValue(library).type) {
      case LibraryTypes.Default:
      case LibraryTypes.MediaBox:
        if (hasParentShelf(toValue(library).parents)) {
          return ViewLibraryDefaultShelf;
        } else if (toValue(library).children.length === 1) {
          return ViewLibraryDefaultLb;
        } else {
          return ViewLibraryRoot;
        }
      case LibraryTypes.FreeLibraryRootBox:
      case LibraryTypes.RootBox:
        return ViewLibraryRoot;
      case LibraryTypes.Shelf:
        if (toValue(library).children.length === 1) {
          return ViewLibraryShelfSingle;
        }
        return ViewLibraryShelf;
    }
  };

  watchEffect(() => {
    view.value = getView();
  });

  return {
    view,
  };
};
